var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addMember" },
    [
      _c(
        "el-dialog",
        {
          staticStyle: { "'margin-top": "50vh" },
          attrs: {
            title: "添加标签",
            visible: _vm.show,
            "modal-append-to-body": false,
            width: "550px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.show = $event
            },
            close: function($event) {
              return _vm.cancelHandle()
            }
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 2 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "选择标签组", size: "small" },
                      on: {
                        change: function($event) {
                          return _vm.groupChange($event)
                        }
                      },
                      model: {
                        value: _vm.codeForm.groupId,
                        callback: function($$v) {
                          _vm.$set(_vm.codeForm, "groupId", $$v)
                        },
                        expression: "codeForm.groupId"
                      }
                    },
                    _vm._l(_vm.groupList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item.groupId, label: item.groupName }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "20px" }, attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.checkedVals,
                        callback: function($$v) {
                          _vm.checkedVals = $$v
                        },
                        expression: "checkedVals"
                      }
                    },
                    _vm._l(_vm.groupTagsList, function(item, index) {
                      return _c(
                        "el-checkbox",
                        {
                          key: index,
                          staticStyle: { "margin-top": "10px" },
                          attrs: { label: item.tagId + "-" + item.tagName }
                        },
                        [_vm._v(_vm._s(item.tagName))]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.cancelHandle()
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.confirmHandle()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }